// Copyright (c) 2019 Deere & Company

import './index.scss';
import React, { Component } from 'react';
import AuthenticatedPage from '../app/common/components/authenticated-page';
import PropTypes from 'prop-types';
import WorkListSearch from './components/workList-panel';

class WorkListPage extends Component {

    state= {
        navParameter: '',
    }

    componentWillReceiveProps ( nextProps ) {

        if ( nextProps.location.state === 'worklist' ) {

            this.setState( {
                navParameter: nextProps.location.state,
            } );

        }

    }

    updateReload = () => {

        this.setState( {
            navParameter: '',
        } );

    }

    render () {

        return (
            <AuthenticatedPage className="worklist-page">
                <WorkListSearch
                    reload={this.state.navParameter}
                    updateReload={this.updateReload}
                />
            </AuthenticatedPage>
        );

    }

}

WorkListPage.displayName = 'WorkListPage';
WorkListPage.propTypes = {
    location: PropTypes.object.isRequired,
};
export default WorkListPage;
